/** Bead dimensions in mm: [width, height] */
export const BEAD_DIMENSIONS: Readonly<Record<string, readonly [number, number]>> = {
  '11/0': [1.6, 1.3],
  '15/0': [1.3, 1.0],
  '8/0': [2.1, 2.0],
} as const;

/** Aspect ratio width:height for seed beads (approx 1:1.3) */
export const BEAD_ASPECT_RATIO = 1.3;

/** Maximum grid dimensions */
export const MAX_GRID_WIDTH = 500;
export const MAX_GRID_HEIGHT = 500;

/** Maximum palette size */
export const MAX_PALETTE_SIZE = 50;
